import ITexts from "./ITexts";

const de: ITexts = {
  donation_project_list_header: "Spende",
  donation_project_list_item_go_to_project: "Zur Organisation",
  donation_1_donate_now_1: "Jetzt ab ",
  donation_1_donate_now_2: " spenden",
  donation_abort_button: "Abbrechen",
  donation_info: "Hinweis: Für die finale Abwicklung der Spende werden Sie auf die sichere Spendenseite der Organisation weitergeleitet. ",
  donation_alert: `<b>Vielen Dank für Ihre Entscheidung, diese Organisation zu unterstützen. </b><br/> <br/>
<i>Hinweis: Für die finale Abwicklung der Spende werden Sie auf die sichere Spendenseite der Organisation weitergeleitet. Dort ist eine erneute Eingabe des Spendenbetrags erforderlich.</i>`,
  donation_info_2: `<b>Möchten Sie eine Spendenbescheinigung erhalten? </b><br/> <br/>

Wenn Sie eine Spendenbescheinigung benötigen, stellen wir diese gerne für Sie aus. <br/> <br/>

<i>*Hinweis: Wenn Sie „Ja“ auswählen, schickt Ihnen die Organisation eine Spendenbescheinigung per E-Mail zu.  
Eine nachträgliche Ausstellung ist möglich, kann jedoch länger dauern. </i>`,
  donation_info_2_1: `<b>Angaben für Ihre Spendenbescheinigung</b> <br/><br/>

Damit die Organisation Ihre Spendenbescheinigung korrekt ausstellen kann, benötigen wir folgende Informationen von Ihnen: `,
  donation_info_3: `<b>Vielen Dank für Ihre Spende! </b><br/><br/>

Mit Ihrer Unterstützung ermöglichen Sie der Organisation, ihre wichtige Arbeit fortzusetzen. <br/><br/>

<b>Möchten Sie noch mehr bewirken?</b><br/><br/>
Auf bettervest können Sie: <br><br>
<ul>
  <li>Weitere geprüfte Organisationen unterstützen</li>
  <li>Über Impact Investments gesellschaftliche Wirkung und finanzielle Renditen erzielen</li>
</ul>
<br><br>
<i>Gemeinsam mit der bettervest Crowd erzielen Sie echten Impact –  für eine bessere Zukunft!</i>
`,
  donation_now_disabled: "Anmelden und spenden",
  donation_continue: "fortsetzen",
  donation_progress_bar_by: "von",
  donation_progress_bar_donator: "Donator",
  donation_progress_bar_donators: "Donatoren",
  donation_side_bar_requiredBudget: "Spendenziel",
  donation_side_bar_region: "Region",
  donation_side_bar_mainFocus: "Hauptfokus",
  donation_side_bar_matchFunding: "Matchfunding",
  donation_close_button: "Close",
  donation_1_hint_project_not_donate: "Derzeit sind Spenden für dieses Projekt nicht möglich",
  donation_1_hint_only_logged_in: "Nur angemeldete Nutzer können Spenden tätigen",
  donation_1_hint_before_start: "Der Spendenzeitraum für dieses Projekt hat noch nicht begonnen",
  donation_1_hint_after_end: "Der Spendenzeitraum für dieses Projekt ist beendet",
  donation_1_donate_btn: "Betrag bestätigen",
  donation_info_tax_btn_yes: "Ja, ich möchte eine Spendenbescheinigung",
  donation_info_tax_btn_no: "Jetzt ohne Bescheinigung spenden",
  donation_3_preview_intro: "Für Ihre Spende werden Ihre aktuellen persönlichen Daten für die Ausstellung der Spendenbescheinigung benötigt.",

  donation_3_preview_call_to_action: "Sind die Daten noch aktuell und korrekt?",
  donation_3_preview_change_profile_button: "Nein, Daten ändern",
  donation_3_preview_continue_button: "Ja, aktuell & korrekt",
  donation_3_edit_title: "Persönliche Daten ändern",
  donation_3_edit_alert_message: "Bitte beachten Sie folgenden Hinweis",
  donation_3_edit_alert_description: "Die Änderung Ihres Nachnamens oder Ihrer Adresse führt zu einer erneuten Identifikation Ihrer Person.",
  donation_3_edit_back_without_save_button: "Zurück",
  donation_3_edit_save_and_back_button: "Speichern und Spenden!",
  donation_3_firstName: "Vorname",
  donation_3_lastName: "Nachname",
  donation_3_country: "Land",
  donation_3_city: "Ort",
  donation_3_postalCode: "Postleitzahl",
  donation_3_streetName: "Straße",
  donation_3_streetNumber: "Hausnummer",
  donation_3_addition: "Zusatz",
  donation_3_address: "Anschrift",
  donation_3_companyDataTitle: "Gesellschaftsbezogene Daten:",
  donation_3_companyName: "Name der Gesellschaft",
  donation_3_legalForm: "Rechtsform",
  donation_3_registerId: "Registernummer",
  donation_3_court: "Registerführende Stelle",
  donation_3_legalAddress: "Geschäftsanschrift",

  donation_3_save_disabled_loading: "Wird gespeichert...",
  donation_3_save_disabled_no_changes: "Keine Änderungen vorhanden",
  donation_3_save_disabled_natural_invalid: "Bitte füllen Sie alle Pflichtfelder der natürlichen Person aus",
  donation_3_save_disabled_legal_invalid: "Bitte füllen Sie alle Pflichtfelder des Unternehmens aus"
};

export default de;
